import { css } from '@emotion/core'
import { colors, zIndexes } from 'styles/variables'

export const container = css`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.black50};
  z-index: ${zIndexes.loader};
`

export const fixed = css`
  position: fixed;
`

export const absolute = css`
  position: absolute;
`
